// extracted by mini-css-extract-plugin
export default {"Logo":"muiSelect_Logo__vOYQ7","FormControl":"muiSelect_FormControl__pKksO","FormControlLoader":"muiSelect_FormControlLoader__2oka8"};